import { render, staticRenderFns } from "./ViewTutorGroups.vue?vue&type=template&id=0fb24665&"
import script from "./ViewTutorGroups.vue?vue&type=script&lang=js&"
export * from "./ViewTutorGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports